import React, { useState, useEffect } from 'react';
import { ModalProgressBar } from '../../../_metronic/_partials/controls';
import { CloseButton, Modal } from 'react-bootstrap';

import Container from 'react-bootstrap/Container';
import { initialFilter } from '../../modules/Products/pages/products/ProductsUIHelpers';
import axios, { baseUrl } from '../../../redux/my-axios';
import Filter from './Filter';
import List from './List';
import css from './style.module.css';

export const PRODUCTS_URL = '/products';
function SelectProduct(props) {
  const {
    intl,
    openSelectProducts,
    setOpenSelectProducts,
    addSelectedItems,
    existingItems,
    multiSelect = true,
  } = props;
  const [queryParams, setQueryParams] = useState(initialFilter);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [entities, setEntities] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [ids, setIds] = useState([]);

  //console.log('multiSelect', multiSelect);
  useEffect(() => {
    axios
      .post(PRODUCTS_URL, queryParams, { headers: { action: 'find' } })
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            console.log('Selected items', response.data.data.list);
            let arr = removeExisting(response.data.data.list);
            //console.log('Filtered items', arr);
            setTotalCount(arr.length);
            setEntities(arr);
            break;
          default:
            var error = response.data.msg.desc;
            setError(error);
            break;
        }
      })
      .catch((error) => {
        setError(error);
      });
  }, [queryParams]);

  useEffect(() => {
    //console.log('ids', ids);
  }, [ids]);

  function removeExisting(allItems) {
    return allItems.filter(
      (item) => !existingItems.find((c) => c.productCode === item.productCode)
    );
  }

  const clickOk = () => {
    let selectedRows = [];
    for (let i = 0; i < ids.length; i++) {
      let selected = entities.find((c) => c.productCode === ids[i]);
      selectedRows.push(selected);
    }
    addSelectedItems(selectedRows);
    back();
  };
  const back = () => {
    setOpenSelectProducts(false);
  };

  const setNewIds = (val) => {
    //console.log('SelectedRow', val);
    if (multiSelect) {
      setIds(val);
    } else {
      let t;
      val.map((i) => {
        t = i;
      });
      setIds([t]);
    }
  };

  return (
    <>
      {loading && <ModalProgressBar />}
      <Modal
        size='xl'
        show={openSelectProducts}
        onHide={back}
        backdrop='static'
        keyboard={false}
        aria-labelledby='example-modal-sizes-title-lg'
      >
        <Modal.Header>
          <Modal.Title id='example-modal-sizes-title-lg'>
            Бүтээгдэхүүн сонгох
          </Modal.Title>
          <CloseButton onClick={back} />
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Filter queryParams={queryParams} setQueryParams={setQueryParams} />
            <List
              entities={entities}
              totalCount={totalCount}
              ids={ids}
              setIds={setNewIds}
              multiSelect={multiSelect}
            />
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' onClick={back} className='btn btn-light'>
            Болих
          </button>
          <> </>
          <button
            type='submit'
            className='btn btn-primary ml-2'
            onClick={clickOk}
          >
            Сонгох
          </button>
        </Modal.Footer>
      </Modal>

      {/*  <CardHeader title='Бүтээгдэхүүн сонгох'>
        <CardHeaderToolbar>
          <button type='button' onClick={back} className='btn btn-light'>
            <i className='fa fa-arrow-left'></i>
            Болих
          </button>
          <> </>
          <button
            type='submit'
            className='btn btn-primary ml-2'
            onClick={clickOk}
          >
            Сонгох
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        
      </CardBody> */}
    </>
  );
}
export default SelectProduct;
